import { cn } from "@/lib/utils";
import HBranchLine from "./HBranchLine";
import type { SectionNavigationSubItemProps } from "./SectionNavigationDialog.types";
import SectionNavigationGrandChildItem from "./SectionNavigationGrandChildItem";

const SectionNavigationSubItem = ({
  subsection,
  isActive,
  activeSection,
  onNavigate,
}: SectionNavigationSubItemProps) => {
  return (
    <div className="relative">
      {/* Subsection */}
      <button
        type="button"
        onClick={() => onNavigate(subsection.id)}
        className={cn(
          "w-full font-normal text-left hover:text-violet-800 px-3 py-1.5 text-sm transition-colors relative",
          "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-1 rounded-xs",
          isActive ? "text-violet-900 font-medium" : "text-gray-900",
        )}
      >
        <HBranchLine active={isActive} />
        {subsection.label}
      </button>

      {/* Purple left border segment for active subsection only */}
      {isActive && (
        <span
          className="absolute left-0 top-0 w-px bg-violet-700 h-full"
          aria-hidden="true"
          style={{ marginLeft: "-1px" }}
        />
      )}

      {/* Grandchildren - Always gray border */}
      {subsection.grandchildren && subsection.grandchildren.length > 0 && (
        <div className="ml-4 mt-0 space-y-0 relative border-l border-gray-300">
          {subsection.grandchildren.map((grandchild) => (
            <SectionNavigationGrandChildItem
              key={grandchild.id}
              grandchild={grandchild}
              isActive={activeSection === grandchild.id}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionNavigationSubItem;
